import { z } from 'zod';

/**
 * The cancellation of a CANCELED voucher (#6787) — who, when and why, as the
 * source writes them in `actions.canceled`. Like `VoucherApprovalSchema`, only
 * the NAME crosses: the canceler's email stays on the source. Each part is
 * `null` when the source did not record it.
 */
export const VoucherCancellationSchema = z.object({
  by: z.string().nullable(),
  at: z.coerce.date().nullable(),
  reason: z.string().nullable(),
});
export type VoucherCancellation = z.infer<typeof VoucherCancellationSchema>;
